exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-cc896500]{overflow:hidden}.body[data-v-cc896500]{height:calc(100% - 40px);padding:20px;overflow-y:auto;overflow-x:hidden}.body>div[data-v-cc896500]{margin:10px 0}.note-view-map[data-v-cc896500]{float:right;width:200px;height:150px}.date[data-v-cc896500],.geocoords[data-v-cc896500],.places[data-v-cc896500]{float:left;clear:left}.places img[data-v-cc896500]{vertical-align:middle}.note[data-v-cc896500]{clear:both;white-space:pre-wrap}a svg[data-v-cc896500]{fill:#42b983}.navigation a[data-v-cc896500]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc896500","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Note.vue
// module id = 218
// module chunks = 0